jQuery(document).ready(function() {
    jQuery('body').append(add_dialog('alert', 'Fout', 'alert'));
    jQuery('body').append(add_dialog('confirm', 'Bevestig', 'confirm'));
});

function jQueryAlert(message, title) {
    if (title != null && title != undefined) jQuery("#modal-alert-content .c-modal__title").html(title);
    else jQuery("#modal-alert-content .c-modal__title").html(jQuery("#modal-alert").data("title"));
    jQuery("#modal-alert-content .c-modal__message").html(message);

    MicroModal.show('modal-alert', {
        openTrigger: 'modal-open',
        closeTrigger: 'modal-close',
        openClass: 'c-modal--open',
        disableScroll: true,
        disableFocus: true,
        awaitOpenAnimation: false,
        awaitCloseAnimation: true,
    });
}

var jQueryConfirmObj;
var jQueryConfirmConfirmed = false
function jQueryConfirm(obj, message, title, strButtonYes, strButtonNo) {
	if (!jQueryConfirmConfirmed) {
		jQueryConfirmObj = obj;
        if (title != null && title != undefined) jQuery("#modal-confirm-content .c-modal__title").html(title);
        else jQuery("#modal-confirm-content .c-modal__title").html(jQuery("#modal-confirm").data("title"));
        if (strButtonYes != null) jQuery("#modal-confirm-content .c-modal__button-yes").html(strButtonYes);
        if (strButtonNo != null) jQuery("#modal-confirm-content .c-modal__button-no").html(strButtonNo);
        jQuery("#modal-confirm-content .c-modal__message").html(message);

        jQuery('#modal-confirm-content .c-modal__button-yes').on('click', function() {
            jQueryConfirmConfirmed = true;
            jQueryConfirmObj.click();
        });

        MicroModal.show('modal-confirm', {
            openTrigger: 'modal-open',
            closeTrigger: 'modal-close',
            openClass: 'c-modal--open',
            disableScroll: true,
            disableFocus: true,
            awaitOpenAnimation: false,
            awaitCloseAnimation: true,
        });
	} else {
		jQueryConfirmConfirmed = false;
		return true;
	 }
}

function jQueryConfirmWithCallback(strID, message, title, strButtonYes, strButtonNo, callback) {
    if (jQuery("#modal-" + strID).length == 0) {
        jQuery('body').append(add_dialog(strID, 'Bevestig', 'confirm'));

        if (title != null && title != undefined) jQuery("#modal-" + strID + "-content .c-modal__title").html(title);
        else jQuery("#modal-" + strID + "-content .c-modal__title").html(jQuery("#modal-" + strID).data("title"));
        if (strButtonYes != null) jQuery("#modal-" + strID + "-content .c-modal__button-yes").html(strButtonYes);
        if (strButtonNo != null) jQuery("#modal-" + strID + "-content .c-modal__button-no").html(strButtonNo);
        jQuery("#modal-" + strID + "-content .c-modal__message").html(message);

        jQuery('#modal-' + strID + '-content .c-modal__button-yes').on('click', function() {
            callback(true);
        });

        jQuery('#modal-' + strID + '-content .c-modal__button-no').on('click', function() {
            callback(false);
        });
    }

    MicroModal.show('modal-' + strID, {
        openTrigger: 'modal-open',
        closeTrigger: 'modal-close',
        openClass: 'c-modal--open',
        disableScroll: true,
        disableFocus: true,
        awaitOpenAnimation: false,
        awaitCloseAnimation: true,
    });
}

function add_dialog(strID, strTitle, strType) {
    var rval = '' +
        '<div class="c-modal c-modal--small" id="modal-' + strID + '" aria-hidden="true" data-title="' + strTitle + '">' +
            '<div class="c-modal__overlay" tabIndex="-1" modal-close="modal-' + strID + '">' +
                '<div class="c-modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-' + strID + '-title">' +
                    '<svg class="c-modal__close c-modal__close--black" aria-label="Close modal" modal-close="modal-' + strID + '" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">' +
                        '<path d="M965.781,534.868l-.743-.743-5.257,5.257-5.257-5.257-.743.743,5.257,5.257-5.257,5.257.743.743,5.257-5.257,5.257,5.257.743-.743-5.257-5.257Z" transform="translate(-953.781 -534.125)"/>' +
                    '</svg>' +
                    '<div class="c-modal__wrapper">' +
                        '<main class="c-modal__content" id="modal-' + strID + '-content">' +
                            '<h2 class="c-modal__title"></h2>' +
                            '<div class="c-modal__message"></div>' +
                            '<div class="o-btn__container c-modal__btn">';
                                if (strType === 'confirm') {
                                    rval += '<button type="button" class="o-btn o-btn--black o-btn--small c-modal__button-yes" modal-close="modal-' + strID + '">Yes</button>';
                                    rval += '<button type="button" class="o-btn o-btn--ghost o-btn--small c-modal__button-no" modal-close="modal-' + strID + '">No</button>';
                                } else {
                                    //rval += '<button type="button" class="o-btn o-btn--black o-btn--small c-modal__button-ok" modal-close="modal-' + strID + '">OK</button>';
                                }
                            rval += '</div>' +
                        '</main>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>' +
        '';

    return rval;
}

